module.exports = __webpack_public_path__ + "img/c01_unitprodromos_Normal_ua.0649d97d.webp";